import React, { useState, useRef, useEffect } from "react";
import { Smartphone, Lock, Eye, EyeOff, Sparkles } from "lucide-react";
import bgImage from "../../Images/BG.webp";
import logo from "../../Images/PACKKKY.png";
import toast from "react-hot-toast";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import useLogin from "../../Sevices/useLogin";

const LoginPage = () => {
  const { login, loading } = useLogin();
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [loginStep, setLoginStep] = useState(1);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [location, setLocation] = useState({
    latitude: "",
    longitude: "",
  });

  const [locationLoading, setLocationLoading] = useState(true);

  const phoneRef = useRef(null);
  const passwordRef = useRef(null);
  const continueBtnRef = useRef(null);
  const otpRefs = useRef([]);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value.slice(0, 10));
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
      return;
    }

    if (e.key === "Enter" && index === 5) {
      const updatedOtp = [...otp];
      updatedOtp[index] = e.currentTarget.value;

      const finalOtp = updatedOtp.join("");

      if (finalOtp.length === 6 && !loading) {
        handleLogin(finalOtp);
      } else {
        toast.error("Please enter complete 6-digit OTP");
      }
    }
  };

  const handleChangeNumber = () => {
    setLoginStep(1);
    setOtp(["", "", "", "", "", ""]);

    setTimeout(() => {
      document.querySelector('input[type="tel"]')?.focus();
    }, 100);
  };

  const handleContinue = async () => {
    if (!phone) {
      toast.error("Please enter mobile number");
      return;
    }

    if (phone.length !== 10) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    if (!password) {
      toast.error("Please enter password");
      return;
    }

    if (loading) return;

    const result = await login({
      mobile: phone,
      password,
      step: 1,
      otp: "",
      latitude: location.latitude || "0.0",
      longitude: location.longitude || "0.0",
    });

    console.log("LOGIN RESULT IN COMPONENT:", result);

    if (!result?.success) {
      toast.error(
        result?.message ||
          "Invalid Credentials. Please check your credentials again.",
      );
      return;
    }

    toast.success(result?.message || "OTP Sent");
    setLoginStep(2);

    setTimeout(() => {
      otpRefs.current[0]?.focus();
    }, 100);
  };

  const handleLogin = async (otpValue = "") => {
  const finalOtp =
    typeof otpValue === "string" && otpValue.length === 6
      ? otpValue
      : otp.join("");

  if (finalOtp.length !== 6) {
    toast.error("Please enter complete 6-digit OTP");
    return;
  }

  if (loading) return;

  try {
    const result = await login({
      mobile: phone,
      password,
      step: 2,
      otp: finalOtp,
      latitude: location.latitude || "0.0",
      longitude: location.longitude || "0.0",
    });

    console.log("LOGIN API RESULT:", result);

    if (result?.success && result?.completed) {
      toast.success("Login Successful");
      navigate("/dashboard");
    } else {
      toast.error(result?.message || "Login failed");
    }
  } catch (error) {
    console.error("LOGIN API ERROR:", error);
    toast.error("Something went wrong while logging in");
  }
};

  useEffect(() => {
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by this browser");

      setLocation({
        latitude: "0.0",
        longitude: "0.0",
      });

      setLocationLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude.toString();
        const longitude = position.coords.longitude.toString();

        setLocation({
          latitude,
          longitude,
        });

        setLocationLoading(false);
      },
      (error) => {
        console.error("Location ERROR:", error);

        setLocation({
          latitude: "0.0",
          longitude: "0.0",
        });

        setLocationLoading(false);

        if (error.code === error.PERMISSION_DENIED) {
          toast.error("Please allow location permission");
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  }, []);

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white">
      {/* Left Section */}
      <div className="flex w-full lg:w-[1060px] relative overflow-hidden text-white min-h-[350px] lg:min-h-screen">
        <img
          src={bgImage}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-emerald-900/10" />

        <div className="relative z-10 flex flex-col justify-center px-36">
          <div className="mb-10">
            <div className="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center">
              <Sparkles size={24} />
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light montserrat-font leading-tight mb-6">
            Hello, Packky Admin!
          </h1>

          <p className="max-w-xl inter-inter  text-[16px] text-white/90 leading-relaxed">
            Smart Delivery Management Software for Restaurants & Businesses in
            India
          </p>

          <p className="mt-16 text-[12px] text-white/70">
            © 2026 Packky. All rights reserved.
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 py-10 lg:py-0">
        <div className="w-full max-w-md">
          {/* Logo */}
          <img src={logo} alt="Logo" className="h-12 mb-10 object-contain" />

          <h2 className="text-[28px] text-slate-900 mb-2">Welcome back!</h2>

          <p className="text-gray-500 text-sm mb-10">
            Don't have an account?{" "}
            <button className="text-orange-500 font-medium hover:underline">
              Create a new account
            </button>
          </p>

          {/* Mobile */}
          <div className="mb-5">
            <label className="block text-[12px] font-medium text-[#374152] mb-1">
              Mobile
            </label>

            <div className="relative">
              <input
                ref={phoneRef}
                type="tel"
                placeholder="Enter 10-digit number"
                value={phone}
                onChange={handlePhoneChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    passwordRef.current?.focus();
                  }
                }}
                maxLength={10}
                disabled={loginStep === 2}
                className="w-full h-10 rounded-xl border border-gray-300 pl-12 pr-4 outline-none focus:ring-2 focus:ring-orange-300 placeholder:text-sm"
              />
              <Smartphone
                size={18}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
              />
            </div>
          </div>

          {/* Password */}
          <div className="mb-6">
            <label className="block text-[12px] font-medium text-[#374152] mb-1">
              Password
            </label>

            <div className="relative">
              <input
                ref={passwordRef}
                type={showPassword ? "text" : "password"}
                placeholder="Your password"
                value={password}
                disabled={loginStep === 2}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    continueBtnRef.current?.focus();
                  }
                }}
                className="w-full h-10 rounded-xl border border-gray-300 pl-12 pr-12 outline-none focus:ring-2 focus:ring-orange-300 placeholder:text-sm"
              />

              <Lock
                size={18}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          {loginStep === 2 && (
            <div className="mb-6">
              <div className="flex items-center justify-between mb-2">
                <label className="block text-[12px] font-medium text-[#374152]">
                  Enter OTP
                </label>

                <button
                  type="button"
                  onClick={handleChangeNumber}
                  className="text-xs text-orange-500 hover:underline"
                >
                  Change Number
                </button>
              </div>

              <div className="flex justify-between gap-2">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (otpRefs.current[index] = el)}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    className="h-12 w-12 rounded-xl border border-gray-300 text-center text-lg font-semibold outline-none focus:ring-2 focus:ring-orange-300"
                  />
                ))}
              </div>
              <button
                type="button"
                onClick={handleContinue}
                disabled={loading}
                className="mt-2 text-xs text-orange-500 hover:underline disabled:opacity-50"
              >
                Resend OTP
              </button>
            </div>
          )}

          {/* Login Button */}
          {loginStep === 1 ? (
            <button
              ref={continueBtnRef}
              onClick={handleContinue}
              disabled={loading}
              className="w-full h-10 text-sm bg-orange-400 hover:bg-orange-500 text-white rounded-xl font-medium"
            >
              {loading ? "Please Wait..." : "Continue"}
            </button>
          ) : (
           <button
  type="button"
  onClick={() => handleLogin()}
  disabled={loading || otp.join("").length !== 6}
  className={`w-full h-10 text-sm text-white rounded-xl font-medium transition ${
    loading || otp.join("").length !== 6
      ? "bg-gray-300 cursor-not-allowed"
      : "bg-orange-400 hover:bg-orange-500"
  }`}
>
  {loading ? "Please Wait..." : "Login Now →"}
</button>
          )}

          <div className="text-center mt-6">
            <button className="text-orange-500 hover:underline text-sm">
              Forgot password?
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
